import { createJSTDate } from "./libs/date";
import { t } from "./libs/i18n";
import { getAppEnv, isMockEnv } from "./libs/utils";

export const readResourceIds = [
  "50f423aa-8ea8-4385-81a1-a7d8da1c4939", // 氏名
  "5419c333-2863-4d57-9272-5f6c6c8989ec", // 住所
  "5ac941bf-88f3-47e3-b2e7-3bb0522aa14b", // 性別
  "612c6a3c-212a-402e-8c89-792a4b3e7889", // 生年月日
  "32df0061-de96-49a6-99d3-764497e64ed6", // 市区町村までの住所
];

export const cityAddressResourceId = "32df0061-de96-49a6-99d3-764497e64ed6";

export const MIYAGI_BOUSAI_RESOURCE_ID = import.meta.env
  .VITE_MIYAGI_BOUSAI_RESOURCE_ID as string;

export const MIYAGI_BOUSAI_SERVICE_ID = import.meta.env
  .VITE_MIYAGI_BOUSAI_SERVICE_ID as string;

export const MIYAGI_PPID_RESOURCE_ID = import.meta.env
  .VITE_MIYAGI_PPID_RESOURCE_ID as string;

export const MARUMORI_PPID_RESOURCE_ID = import.meta.env
  .VITE_MARUMORI_PPID_RESOURCE_ID as string;

export const KYOTO_KYOTO_PPID_RESOURCE_ID = import.meta.env
  .VITE_KYOTO_KYOTO_PPID_RESOURCE_ID as string;

export const DEMO_PPID_RESOURCE_ID = import.meta.env.VITE_DEMO_PPID_RESOURCE_ID;

export const TENANT_PPID_RESOURCE_ID_MAP = {
  miyagi: MIYAGI_PPID_RESOURCE_ID,
  marumori: MARUMORI_PPID_RESOURCE_ID,
  "kyoto-kyoto": KYOTO_KYOTO_PPID_RESOURCE_ID,
  demo: DEMO_PPID_RESOURCE_ID,
};

// クッションミニアプリ系
export const CUSHION_SERVICE_ID = import.meta.env.VITE_CUSHION_SERVICE_ID;
// フォールバック用のテナントのサービスID
// 複数のテナントに対応しているQRコードだが、どのミニアプリもサブスクしていない場合、このミニアプリを開く
export const CUSHION_FALLBACK_SERVICE_ID = import.meta.env
  .VITE_MIYAGI_SERVICE_ID;

export const MIYAGI_INVITATION_FUND_SOURCE_ID =
  "0662db98-9fd2-4db3-931d-945bc002f076";

// 友達紹介キャンペーン開始日時
export const INVITATION_START_DATE = createJSTDate("2025-07-01 08:00:00");

// 友達紹介キャンペーン終了日時
export const INVITATION_END_DATE = createJSTDate("2025-11-30 23:59:59");

// 一次抽選終了日時
export const PRIMARY_CAMPAIGN_END_DATE = createJSTDate("2025-01-25 23:59:59");

// ポイント利用期間終了日時
export const POINT_EXPIRATION_DATE = createJSTDate("2025-02-28 23:59:59");

// R7みやぎキャンペーン開始日時
export const R7_MIYAGI_CAMPAIGN_START_DATE = createJSTDate(
  "2025-07-01 08:00:00",
);

// R7みやぎキャンペーン終了日時
export const R7_MIYAGI_CAMPAIGN_END_DATE = createJSTDate("2026-06-30 23:59:59");

// 「みやぎ防災」ウェルカムポイントキャンペーン開始日時
export const MIYAGI_BOUSAI_WELCOME_CAMPAIGN_START_DATE = createJSTDate(
  "2026-08-01 09:00:00",
);

// 「みやぎ防災」ウェルカムポイントキャンペーン終了日時
export const MIYAGI_BOUSAI_WELCOME_CAMPAIGN_END_DATE = createJSTDate(
  "2027-03-31 23:59:59",
);

// 事業名は固有名詞なのでカタログに入れず定数で持つ
export const MIYAGI_RESIDENCE_CARD_CAMPAIGN_NAME =
  "ようこそみやぎ外国人ポイント";

// ようこそみやぎ外国人ポイント開始日時（令和8年10月20日 正午）
export const MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE = createJSTDate(
  "2026-10-20 12:00:00",
);

// ようこそみやぎ外国人ポイント終了日時（令和9年3月31日）
export const MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE = createJSTDate(
  "2027-03-31 23:59:59",
);

// 署名用電子証明書は原則15歳未満に発行されないため、これ未満は4桁の暗証番号での受け取りを認める。
// バックエンドの付与時判定（core.signingCertificateMinAge）と揃える
export const DIGITAL_SIGNATURE_MIN_AGE = 15;

// KLON（県民公式アプリ）が公開する特定在留カード等リソースのID（全環境共通）
// https://www.notion.so/pocketsign/3bfef16cba618056a89df02851d6ead9
export const RESIDENCE_CARD_CAPABILITY_RESOURCE_ID =
  "80e2b182-5977-466a-b8f1-0c917eee01dd"; // klon/residence_card_capability
export const RESIDENCE_CARD_EXPIRY_DATE_RESOURCE_ID =
  "4648d032-45a5-49e2-ba03-9644d6724e7d"; // klon/residence_card_expiry_date

// R7まるもりキャンペーン開始日時
export const R7_MARUMORI_CAMPAIGN_START_DATE = createJSTDate(
  "2025-09-01 09:00:00",
);

// R7まるもりキャンペーン終了日時
export const R7_MARUMORI_CAMPAIGN_END_DATE = createJSTDate(
  "2025-12-31 23:59:59",
);

// R7大津市キャンペーン開始日時
export const R7_SHIGA_OTSU_CAMPAIGN_START_DATE = createJSTDate(
  "2025-09-01 00:00:00",
);

// 大崎市キャンペーン開始日時
export const OSAKI_CAMPAIGN_START_DATE = createJSTDate("2026-01-13 09:00:00");
// 大崎市キャンペーン終了日時
export const OSAKI_CAMPAIGN_END_DATE = createJSTDate("2026-02-28 23:59:59");

// 仙台市キャンペーン開始日時
export const SENDAI_CAMPAIGN_START_DATE = createJSTDate("2026-01-21 09:00:00");
// 仙台市キャンペーン終了日時
export const SENDAI_CAMPAIGN_END_DATE = createJSTDate("2026-06-30 23:59:59");

// 白石市キャンペーン開始日時
export const SHIROISHI_CAMPAIGN_START_DATE = createJSTDate(
  "2026-04-01 10:00:00",
);
// 白石市キャンペーン終了日時
export const SHIROISHI_CAMPAIGN_END_DATE = createJSTDate("2026-06-30 23:59:59");

// 多賀城市キャンペーン開始日時
export const TAGAJO_CAMPAIGN_START_DATE = createJSTDate("2026-02-03 10:00:00");
// 多賀城市キャンペーン終了日時
export const TAGAJO_CAMPAIGN_END_DATE = createJSTDate("2026-04-30 23:59:59");

// 気仙沼市キャンペーン開始日時
export const KESENNUMA_CAMPAIGN_START_DATE = createJSTDate(
  "2026-02-10 09:00:00",
);
// 気仙沼市キャンペーン終了日時
export const KESENNUMA_CAMPAIGN_END_DATE = createJSTDate("2026-03-31 23:59:59");

// 登米市キャンペーン開始日時
export const TOME_CAMPAIGN_START_DATE = createJSTDate("2026-09-01 00:00:00");
// 登米市キャンペーン終了日時（申請期限）
export const TOME_CAMPAIGN_END_DATE = createJSTDate("2026-12-31 23:59:59");

// 登米市キャンペーンの対象生年月日範囲（平成20年4月2日〜令和8年11月30日生まれの児童が対象）
export const TOME_TARGET_BIRTHDAY_FROM = new Date("2008-04-02");
export const TOME_TARGET_BIRTHDAY_TO = new Date("2026-11-30");

// 京都市代理受け取りキャンペーン開始日時
export const KYOTO_REPRESENTATIVE_CAMPAIGN_START_DATE = createJSTDate(
  "2026-08-01 10:00:00",
);
export const KYOTO_REPRESENTATIVE_CAMPAIGN_REWARD = 5000;
export const KYOTO_REPRESENTATIVE_WARNING_COUNT = 5;
export const KYOTO_REPRESENTATIVE_LIMIT = 10;

export type OsakiChargeBonusCampaignTerm = "1st" | "2nd" | "3rd";

export type OsakiChargeBonusCampaignPeriod = {
  term: OsakiChargeBonusCampaignTerm;
  // 曜日つき・曜日なしの両表記をここから組む。購入開始日と同日だが、
  // 発表と購入開始がずれても壊れないよう独立したフィールドで持つ
  lotteryResultAnnouncementDate: Date;
  applicationStartDate: Date;
  applicationEndDate: Date;
  purchaseStartDate: Date;
  purchaseEndDate: Date;
};

export const OSAKI_CHARGE_BONUS_CAMPAIGN_PERIODS: OsakiChargeBonusCampaignPeriod[] =
  [
    {
      term: "1st",
      lotteryResultAnnouncementDate: createJSTDate("2026-06-23"),
      applicationStartDate: createJSTDate("2026-06-08 09:00:00"),
      applicationEndDate: createJSTDate("2026-06-22 23:59:59"),
      purchaseStartDate: createJSTDate("2026-06-23 09:00:00"),
      purchaseEndDate: createJSTDate("2026-07-07 23:59:59"),
    },
    {
      term: "2nd",
      lotteryResultAnnouncementDate: createJSTDate("2026-07-23"),
      applicationStartDate: createJSTDate("2026-07-08 17:00:00"),
      applicationEndDate: createJSTDate("2026-07-22 23:59:59"),
      purchaseStartDate: createJSTDate("2026-07-23 09:00:00"),
      purchaseEndDate: createJSTDate("2026-07-31 23:59:59"),
    },
    {
      term: "3rd",
      lotteryResultAnnouncementDate: createJSTDate("2026-09-08"),
      applicationStartDate: createJSTDate("2026-08-24 08:30:00"),
      applicationEndDate: createJSTDate("2026-09-07 23:59:59"),
      purchaseStartDate: createJSTDate("2026-09-08 08:30:00"),
      purchaseEndDate: createJSTDate("2026-09-27 23:59:59"),
    },
  ];

// 気仙沼市年齢制限の基準日（平成19年4月1日以前生まれが対象）
export const KESENNUMA_AGE_CUTOFF_DATE = new Date("2007-04-01");

// 北海道どうみんポイント給付事業 開始日時
export const HOKKAIDO_HOUSEHOLDER_CAMPAIGN_START_DATE = createJSTDate(
  "2026-06-25 00:00:00",
);
// 北海道どうみんポイント給付事業 終了日時
export const HOKKAIDO_HOUSEHOLDER_CAMPAIGN_END_DATE = createJSTDate(
  "2026-11-16 23:59:59",
);
// 北海道 マイナポータル申請のホーム導線を全員に出す日時。それまでは申請ページを開いた端末にだけ出す
export const HOKKAIDO_MYNA_APPLICATION_PUBLIC_RELEASE_DATE = createJSTDate(
  "2026-11-05 16:00:00",
);

// 生年月日リソースID
export const birthdayResourceId = "612c6a3c-212a-402e-8c89-792a4b3e7889";

// アプリ名は固有名詞なので t() に載せない。英語表記にするかは en を実際に出す時点の製品判断
export const TENANT_APP_NAMES: Record<string, string> = {
  miyagi: "みやぎポイント",
  "shiga-otsu": "ポイント",
};

// 市町村キャンペーン地域の型（県バナーMNC再読込案内）
export type MunicipalCampaignRegion = {
  key: string;
  name: string;
  startDate: Date;
  endDate: Date;
  campaignPeriodText: string;
};

// 市町村キャンペーン地域リスト（表示順）
export const MUNICIPAL_CAMPAIGN_REGIONS: MunicipalCampaignRegion[] = [
  {
    key: "osaki",
    name: t("大崎市"),
    startDate: OSAKI_CAMPAIGN_START_DATE,
    endDate: OSAKI_CAMPAIGN_END_DATE,
    campaignPeriodText: t("令和8年1月13日から2月28日まで"),
  },
  {
    key: "osaki-charge-bonus",
    name: t("大崎市"),
    startDate: OSAKI_CHARGE_BONUS_CAMPAIGN_PERIODS[0].applicationStartDate,
    endDate: OSAKI_CHARGE_BONUS_CAMPAIGN_PERIODS[0].applicationEndDate,
    campaignPeriodText: t("令和8年6月8日から6月22日まで"),
  },
  {
    key: "sendai",
    name: t("仙台市"),
    startDate: SENDAI_CAMPAIGN_START_DATE,
    endDate: SENDAI_CAMPAIGN_END_DATE,
    campaignPeriodText: t("令和8年1月21日から6月30日まで"),
  },
  {
    key: "shiroishi",
    name: t("白石市"),
    startDate: SHIROISHI_CAMPAIGN_START_DATE,
    endDate: SHIROISHI_CAMPAIGN_END_DATE,
    campaignPeriodText: t("令和8年4月1日から6月30日まで"),
  },
  {
    key: "tagajo",
    name: t("多賀城市"),
    startDate: TAGAJO_CAMPAIGN_START_DATE,
    endDate: TAGAJO_CAMPAIGN_END_DATE,
    campaignPeriodText: t("令和8年2月3日から4月30日まで"),
  },
  {
    key: "kesennuma",
    name: t("気仙沼市"),
    startDate: KESENNUMA_CAMPAIGN_START_DATE,
    endDate: KESENNUMA_CAMPAIGN_END_DATE,
    campaignPeriodText: t("令和8年2月10日から3月31日まで"),
  },
  // 今後の地域追加はここに追加する
  // 登米市は掲載する調整をしていないため載せない
];

// R8物価高騰対策キャンペーン設定（市区町村別）
export type R8CampaignConfig = {
  key: string;
  cityPrefix: string;
  startDate: Date;
  endDate: Date;
  bannerTitle: string;
  bannerDescription: string;
  guideSteps: string;
  guideReceiveDeadline: string;
  guideUseDeadline: string;
  guideNotes: string;
  // 詳細ページを設けない事業では省く。この有無が詳細リンクを出すかどうかを決める。
  // 使わない値を置くと他事業の詳細ページを指してしまう（"miyagi" は防災ウェルカムポイント）
  aboutCampaignType?:
    | "osaki"
    | "sendai"
    | "shiroishi"
    | "tagajo"
    | "kesennuma"
    | "tome"
    | "miyagi";
  hideDeadlineGuide?: boolean;
  // 未指定時は「キャンペーン詳細」
  detailLinkText?: string;
  // received を返すのは「みやぎ防災」ウェルカムポイントとようこそみやぎ外国人ポイントのみ
  receivedText?: string;
  // 登米市は「応募」ではなく「申請」の文言を使う。未指定時は「応募する」
  applyButtonText?: string;
  // 未指定時は「応募手順」
  guideTitle?: string;
  // 未指定時は「応募済み」
  appliedText?: string;
  // 登米市は郵送通知の記載に合わせるため期間ラベルを変える。未指定時は「ポイント受取期限」
  guideReceiveLabel?: string;
  // 未指定時は「ポイント使用期限」
  guideUseLabel?: string;
  // 15歳以上に署名用電子証明書での登録を求める。バックエンドの FundSource.RequiredCertificateAnyOf と揃える
  requiresDigitalSignature?: boolean;
  // 後発のデザインのボタン（文言の右に矢印、「準備する」も青、無効時は文字もグレー）
  modernButtons?: boolean;
};

export const R8_CAMPAIGN_CONFIGS: Record<string, R8CampaignConfig> = {
  miyagiBousaiWelcome: {
    key: "miyagi-bousai-welcome",
    cityPrefix: "宮城県",
    startDate: MIYAGI_BOUSAI_WELCOME_CAMPAIGN_START_DATE,
    endDate: MIYAGI_BOUSAI_WELCOME_CAMPAIGN_END_DATE,
    bannerTitle: t(
      "令和9年3月31日までの期間、\n「みやぎ防災」ウェルカムポイントの付与を実施中！",
    ),
    bannerDescription: t(
      "「みやぎ防災」ミニアプリを登録した方に、その場で3,000ポイントをプレゼントします。",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「応募する」を押します。\n③「みやぎ防災」の登録を行います。\n④ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和9年3月31日まで"),
    guideUseDeadline: t("令和10年3月31日まで"),
    guideNotes: t(
      "・対象者はポイントを応募する時点で宮城県に住民登録のある方です。",
    ),
    aboutCampaignType: "miyagi",
    detailLinkText: t("「みやぎ防災」ウェルカムポイント詳細"),
    receivedText: t(
      "令和8年6月30日以前のキャンペーンに応募済みであるため、ポイント付与の対象外となります。",
    ),
  },
  miyagiResidenceCard: {
    key: "miyagi-residence-card",
    cityPrefix: "宮城県",
    startDate: MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE,
    endDate: MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE,
    bannerTitle: t("「{name}」の付与を実施中！", {
      name: MIYAGI_RESIDENCE_CARD_CAMPAIGN_NAME,
    }),
    bannerDescription: t(
      "特定在留カードまたは特定特別永住者証明書をお持ちの宮城県民の方に、その場で3,000ポイントをプレゼントします。",
    ),
    applyButtonText: t("ポイントの受け取りへ"),
    guideTitle: t("受け取り手順"),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチし、英数字6〜16桁の暗証番号（署名用電子証明書）を入力して登録します（特定在留カードをお持ちか確認できていない方は、先に数字4桁の暗証番号での読み取りを行います。署名用電子証明書で登録済みの方は省略され、②から開始します）。\n②「ポイントの受け取りへ」を押します。\n③「みやぎ防災」の登録を行います（登録済みの方は省略されます）。\n④特定在留カード等の情報取得に同意します。\n⑤マイナンバーカードの数字4桁の暗証番号と在留カード等番号を入力し、特定在留カードをかざして読み取ります。\n⑥ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和9年3月31日まで"),
    guideUseDeadline: t("令和10年3月31日まで"),
    guideNotes: t(
      "・対象者はポイントを受け取る時点で宮城県に住民登録があり、特定在留カードまたは特定特別永住者証明書をお持ちの方です。\n・受け取りはお一人につき1回限りです。\n・15歳未満の方は①で、数字4桁の暗証番号でマイナンバーカードを読み取ってください（署名用電子証明書での登録は不要です）。",
    ),
    requiresDigitalSignature: true,
    modernButtons: true,
    receivedText: t("{name}は受け取り済みです。", {
      name: MIYAGI_RESIDENCE_CARD_CAMPAIGN_NAME,
    }),
  },
  osaki: {
    key: "osaki",
    cityPrefix: "宮城県大崎市",
    startDate: OSAKI_CAMPAIGN_START_DATE,
    endDate: OSAKI_CAMPAIGN_END_DATE,
    bannerTitle: t(
      "大崎市限定！ 2026年2月28日まで\nポイント付与事業を実施中！",
    ),
    bannerDescription: t(
      "大崎市民全員にその場で5,000ポイントをプレゼントします。",
    ),
    guideSteps: t(
      "① 登録日が１日より前など住所の再確認が必要な方は「準備する」を押し、マイナンバーカードをタッチ。\n② 「応募する」を押す。\n③ 大崎市にお住まいの方にポイントが付与されます。",
    ),
    guideReceiveDeadline: t("2026年2月28日まで"),
    guideUseDeadline: t("2026年5月31日まで"),
    guideNotes: t(
      "ポイント付与実績を管理するため、応募いただいた方の住所、氏名、生年月日、性別を、宮城県から大崎市に提供する場合があります。ご了承の上で応募いただくようお願いします。",
    ),
    aboutCampaignType: "osaki",
  },
  sendai: {
    key: "sendai",
    cityPrefix: "宮城県仙台市",
    startDate: SENDAI_CAMPAIGN_START_DATE,
    endDate: SENDAI_CAMPAIGN_END_DATE,
    bannerTitle: t("せんだい生活応援！！\nポイントキャンペーンを実施中！"),
    bannerDescription: t(
      "仙台市民の皆様にその場で3,000ポイントをプレゼントします。",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「応募する」を押します。\n③ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和８年６月３０日まで"),
    guideUseDeadline: t("令和８年１２月３１日まで"),
    guideNotes: t(
      "・対象者はポイントを応募する時点で仙台市に住民登録のある方です。\n・抽選ではありません。\n・ポイント付与実績を管理するため、応募いただいた方の住所、氏名、生年月日、性別を宮城県から仙台市に提供する場合があります。ご了承の上で応募いただくようお願いいたします。",
    ),
    aboutCampaignType: "sendai",
  },
  shiroishi: {
    key: "shiroishi",
    cityPrefix: "宮城県白石市",
    startDate: SHIROISHI_CAMPAIGN_START_DATE,
    endDate: SHIROISHI_CAMPAIGN_END_DATE,
    bannerTitle: t("しろいし生活応援ポイントをプレゼント！"),
    bannerDescription: t(
      "「みやぎ防災」ミニアプリに登録した白石市民の皆様に、その場で3,000ポイントをプレゼントします。",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「応募する」を押します。\n③「みやぎ防災」の登録を行います。\n④ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和８年６月３０日まで"),
    guideUseDeadline: t("令和８年１２月３１日まで"),
    guideNotes: t(
      "・対象者はポイントを応募する時点で白石市に住民登録のある方です。",
    ),
    aboutCampaignType: "shiroishi",
  },
  tagajo: {
    key: "tagajo",
    cityPrefix: "宮城県多賀城市",
    startDate: TAGAJO_CAMPAIGN_START_DATE,
    endDate: TAGAJO_CAMPAIGN_END_DATE,
    bannerTitle: t(
      "【多賀城市】令和８年４月３０日までの期間、ポイント付与を実施中！",
    ),
    bannerDescription: t(
      "多賀城市民（現時点で多賀城市に住民登録がある方）に、その場で3,000ポイントをプレゼント！",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「応募する」を押します。\n③ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和８年４月３０日まで"),
    guideUseDeadline: t("令和８年１０月３１日まで"),
    guideNotes: t(
      "・ポイント付与実績を管理するため、応募いただいた方の住所、氏名、生年月日、性別を宮城県から多賀城市に提供する場合があります。ご了承の上で応募いただくようお願いいたします。",
    ),
    aboutCampaignType: "tagajo",
    hideDeadlineGuide: true,
  },
  kesennuma: {
    key: "kesennuma",
    cityPrefix: "宮城県気仙沼市",
    startDate: KESENNUMA_CAMPAIGN_START_DATE,
    endDate: KESENNUMA_CAMPAIGN_END_DATE,
    bannerTitle: t("気仙沼市物価高騰対策事業で\n「みやポ」を付与します！"),
    bannerDescription: t(
      "19歳以上（平成19年4月1日以前生まれ）の気仙沼市民に、その場で5,000ポイントをプレゼント！",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「応募する」を押します。\n③「みやぎ防災」の登録を行います。\n④ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和８年３月３１日まで"),
    guideUseDeadline: t("令和８年１１月３０日まで"),
    guideNotes: t(
      "ポイント付与実績を管理するため、応募いただいた方の住所、氏名、生年月日、性別を、宮城県から気仙沼市に提供する場合があります。ご了承の上で応募いただくようお願いします。",
    ),
    aboutCampaignType: "kesennuma",
  },
  tome: {
    key: "tome",
    cityPrefix: "宮城県登米市",
    startDate: TOME_CAMPAIGN_START_DATE,
    endDate: TOME_CAMPAIGN_END_DATE,
    // 見出しは登米市の修正依頼（260901_修正依頼_キャンペーンバナー 登米市.xlsx）の文言。
    // 原文は改行なしだが、狭い端末で「！」だけが折り返されるため従来と同じ位置で改行する。
    bannerTitle: t("とめ子育て応援ポイント\n事業を実施中！"),
    bannerDescription: t(
      "対象のお子様にその場で5,000ポイントをプレゼントします。",
    ),
    guideSteps: t(
      "①「準備する」を押して、マイナンバーカードをタッチします（1日以内にカードを登録した方などは省略され、②から開始します）。\n②「申請する」を押します。\n③ポイントが付与されます。",
    ),
    guideReceiveDeadline: t("令和8年12月31日まで"),
    guideUseDeadline: t("令和9年1月31日まで"),
    guideNotes: t(
      "・ご対象者はポイントを申請する時点（令和8年9月1日から令和8年12月31日まで）で登米市に住民登録のある方かつ平成20年4月2日から令和8年11月30日までに生まれた方です。\n・ポイントを利用できるのは市内の参加店のみです。それ以外の店舗ではご利用できません。\n・ポイント付与実績を管理するため、申請いただいた方の住所、氏名、生年月日、性別を宮城県から登米市に提供する場合があります。ご了承の上で申請いただくようお願いいたします。",
    ),
    aboutCampaignType: "tome",
    applyButtonText: t("申請する"),
    guideTitle: t("申請手順"),
    appliedText: t("申請済み"),
    guideReceiveLabel: t("ポイント申請・付与期間"),
    guideUseLabel: t("ポイント利用期間"),
  },
};

// まるもり決済機能有効化日時
export const MARUMORI_PAYMENT_ENABLE_DATE = createJSTDate(
  "2025-10-01 00:00:00",
);

export function getProfileResourceIds(tenantSlug: string) {
  const profileResourceIds =
    tenantSlug === "miyagi"
      ? [...readResourceIds, MIYAGI_BOUSAI_RESOURCE_ID]
      : readResourceIds;

  return profileResourceIds;
}

export function getSubscriptionIdResourceId(tenantSlug: string) {
  const mock = isMockEnv();
  const appEnv = getAppEnv();

  // prod/mockモック環境のResourceIDを分ける
  if (appEnv === "prod/mock" && mock) {
    if (tenantSlug === "miyagi") {
      return import.meta.env.VITE_MIYAGI_MOCK_PPID_RESOURCE_ID as string;
    }
    if (tenantSlug === "marumori") {
      return import.meta.env.VITE_MARUMORI_MOCK_PPID_RESOURCE_ID as string;
    }
  }

  if (tenantSlug === "demo") {
    return import.meta.env.VITE_DEMO_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "miyagi") {
    return import.meta.env.VITE_MIYAGI_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "marumori") {
    return import.meta.env.VITE_MARUMORI_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "shiga-otsu") {
    return import.meta.env.VITE_SHIGA_OTSU_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "shiga-otsu-pay") {
    return import.meta.env.VITE_SHIGA_OTSU_PAY_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "kyoto-kyoto") {
    return import.meta.env.VITE_KYOTO_KYOTO_PPID_RESOURCE_ID as string;
  }
  if (tenantSlug === "hokkaido") {
    return import.meta.env.VITE_HOKKAIDO_PPID_RESOURCE_ID as string;
  }

  throw new Error("Invalid tenant slug");
}
